__turbopack_context__.v({
  "Banner": "oQ_Xla_Banner",
  "Chevron": "oQ_Xla_Chevron",
  "Inline": "oQ_Xla_Inline",
  "Link": "oQ_Xla_Link",
  "Minimized": "oQ_Xla_Minimized",
  "Sticky": "oQ_Xla_Sticky",
  "StickyViewport": "oQ_Xla_StickyViewport",
  "Text": "oQ_Xla_Text",
  "orbit": "oQ_Xla_orbit",
  "sweep": "oQ_Xla_sweep",
});
